<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="19">
				<el-col :span="3">
					<!--RO/No-->
					<ro-apcn-search-input
						:label="getMessage_('QWCC000976')"
						paramKey="roNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<!--차량 VIN-->
					<ro-apcn-search-input
						:label="getMessage_('QWCC000960')"
						paramKey="carVin"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>

				<el-col :span="3">
					<!--제품 ID-->
					<ro-apcn-search-input
						:label="getMessage_('QWCC001538')"
						paramKey="pmcId"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<!--캠페인번호-->
					<ro-apcn-search-input
						:label="getMessage_('MWCC001024')"
						paramKey="cmpnNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<!--딜러점-->
					<ro-apcn-search-input
						:label="getMessage_('QWCC000959')"
						paramKey="dlrCpnyCd"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<!--원인 부품번호 -->
					<ro-apcn-search-input
						:label="getMessage_('QWCC000975')"
						paramKey="causPartNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>

				<!--정비유형-->
				<el-col :span="2">
					<ro-apcn-select2 ref="roSelect2" />
				</el-col>

				<!--CTYPE-->
				<el-col :span="4">
					<ro-apcn-select5 ref="roSelect5" />
				</el-col>

				
				<!--R/O 신청일
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('QWCC001173')">
						<el-date-picker
							v-model="searchAplcDdDt"
							@change="changeSearchAplcDdDt"
							type="daterange"
							align="right"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							range-separator="~"
							format="yyyy-MM-dd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>

				//R/O 확정일
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('QWCC001174')">
						<el-date-picker
							v-model="searchDcsnDdDt"
							@change="changeSearchDcsnDdDt"
							type="daterange"
							align="right"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							range-separator="~"
							format="yyyy-MM-dd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
				-->
			</el-row>
			<el-row :gutter="19">
				<el-col :span="2">
					<!--操作代码causOpCd-->
					<ro-apcn-search-input
						:label="getMessage_('QWCC001096')"
						paramKey="causOpCd"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>

				<el-col :span="2">
					<!-- 出库状态 -->
					<ro-apcn-select7 ref="roSelect7" />
				</el-col>
				<!--처리단계-->
				<el-col :span="2">
					<ro-apcn-select1 ref="roSelect1" />
				</el-col>

				<!--처리결과-->
				<el-col :span="2">
					<ro-apcn-select3 ref="roSelect3" />
				</el-col>

				<!--처리단계-->
				<el-col :span="2">
					<ro-apcn-select6 ref="roSelect6" />
				</el-col>

				<!--날짜구분-->
				<el-col :span="2">
					<ro-apcn-select4 ref="roSelect4" />
				</el-col>

				<!--검색날짜-->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('QWCC001394')">
						<el-date-picker
							v-model="searchDate"
							@change="changeSearchDate"
							type="daterange"
							align="right"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							range-separator="~"
							format="yyyy-MM-dd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>

				<el-col :span="3">
					<!--신청자-->
					<ro-apcn-search-input :label="getMessage_('QWCC001251')" paramKey="aplcNm" />
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RoApcn/store/helpers';
import roApcnSearchInput from './RoApcnSearchInput.vue';
import roApcnSelect1 from './RoApcnSelect1.vue';
import roApcnSelect2 from './RoApcnSelect2.vue';
import roApcnSelect3 from './RoApcnSelect3.vue';
import roApcnSelect4 from './RoApcnSelect4.vue';
import roApcnSelect5 from './RoApcnSelect5.vue';
import roApcnSelect6 from './RoApcnSelect6.vue';
import roApcnSelect7 from './RoApcnSelect7.vue';
import qmsUtils from '@/store/qms/api';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //클레임 승인현황에서 시작일자 가져옴
		pEndDt: { type: String, default: '' }, //클레임 승인현황에서 종료일자 가져옴
		pState1: { type: String, default: '' }, //클레임 승인현황에서 처리단계 가져옴
		pState2: { type: String, default: '' }, //클레임 승인현황에서 처리결과 가져옴
		pState3: { type: String, default: '' }, //클레임 승인현황에서 날짜 검색조건 가져옴
		pState4: { type: String, default: '' }, //클레임 승인현황에서 정비유형 가져옴
		pState5: { type: String, default: '' } 
	},

	data() {
		return {
			searchDate: ['', '']
		};
	},
	components: { roApcnSearchInput, roApcnSelect1, roApcnSelect2, roApcnSelect3, roApcnSelect4, roApcnSelect5, roApcnSelect6, roApcnSelect7 },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList() {
			this.$sf_toggleLoading(true);
			this.getRoApcnList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		changeSearchDate(data) {
			let from;
			let to;

			if (data) {
				from = this.$moment(data[0]).format('YYYY-MM-DD');
				to = this.$moment(data[1]).format('YYYY-MM-DD');
			} else {
				from = '';
				to = '';
			}

			this.searchDate = [from, to];
			this.setSearchParam_({ key: 'roStartDt', value: from });
			this.setSearchParam_({ key: 'roEndDt', value: to });
		}
	},
	async created() {
		try {
			await this.getCommCodes_({ key: 'ceqSearchTypeList', codeType: 'CEQ_TYPE' }) //정비유형
				.then(() => this.getCommCodes_({ key: 'prcsStepList', codeType: 'PRCS_STEP' })) //처리단계
				.then(() => this.getCommCodes_({ key: 'prcsRsltList', codeType: 'PRCS_RSLT' })) //처리결과
				.then(() => this.getCommCodes_({ key: 'roDdList', codeType: 'PWA_DD' })) //날짜구분
				.then(() => this.getCommCodes_({ key: 'sCtypeList', codeType: 'CTYPE' })
				.then(() => this.getCommCodes_({ key: 'rptpStList', codeType: 'RPTP_ST_CST'}))) //날짜구분
				.then(() => this.getCommCodes_({ key: 'outBoundStatusList', codeType: 'YN'}));

			//state안에 초기화 되어있는 값을 개터스 함수로 꺼내서 셋팅한다.
			//this.searchAplcDdDt = [this.getStartAplcDd_, this.getEndAplcDd_];
			//this.searchDcsnDdDt = [this.getStartDcsnDd_, this.getEndDcsnDd_];

			/*클레임 승인내역에서 넘어오는 파라미터 값 시작*/
			let pStartDt = this.pStartDt || '';
			let pEndDt = this.pEndDt || '';
			let pState1 = this.pState1 || ''; // 처리결과
			let pState2 = this.pState2 || ''; // 처리단계
			let pState3 = this.pState3 || ''; // 날짜 검색조건
			let pState4 = this.pState4 || ''; // 날짜 정비유형
			let pState5 = this.pState5 || ''; // 날짜 정비유형

			pStartDt = pStartDt != '' ? this.$moment(pStartDt).format('YYYY-MM-DD') : '';
			pEndDt = pEndDt != '' ? this.$moment(pEndDt).format('YYYY-MM-DD') : '';

			//협력사일경우
			if (this.isMqyStation) {
				let result = await qmsUtils.getDeptNm(this.user.deptCd);

				this.setSearchParam_({ key: 'dlrCpnyCd', value: result.deptCd });
				// this.onChange({key: 'dlrCpnyCd', value: result.deptCd });
				
			} else {
				this.setSearchParam_({ key: 'dlrCpnyCd', value: '' });
			}

			//해당부분 초기화
			this.setSearchParam_({ key: 'prcRsltCd', value: '' });
			this.setSearchParam_({ key: 'prcStepGb', value: '' });
			this.setSearchParam_({ key: 'prcPwaDd', value: '' });
			if (!pStartDt && pEndDt) {
				this.setSearchParam_({ key: 'roStartDt', value: this.getStartAplcDd_ });
				this.setSearchParam_({ key: 'roEndDt', value: this.getEndAplcDd_ });
				this.searchDate = [this.getStartAplcDd_, this.getEndAplcDd_];
			} else {
				this.setSearchParam_({ key: 'prcRsltCd', value: pState1 });
				this.setSearchParam_({ key: 'prcStepGb', value: pState2 });
				this.setSearchParam_({ key: 'prcPwaDd', value: pState3 });
				this.setSearchParam_({ key: 'ceqType', value: pState4 });
				this.setSearchParam_({ key: 'rptpStCd', value: pState5 });
				this.setSearchParam_({ key: 'roStartDt', value: pStartDt });
				this.setSearchParam_({ key: 'roEndDt', value: pEndDt });
				this.searchDate = [pStartDt, pEndDt];
			}

			this.$refs.roSelect1.processInfo();
			this.$refs.roSelect2.processInfo();
			this.$refs.roSelect3.processInfo();
			this.$refs.roSelect4.processInfo();
			this.$refs.roSelect5.processInfo();
			this.$refs.roSelect6.processInfo();

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
